import React from 'react';
import styled from 'styled-components';
import {device} from '../../assets/device'
import EventSportDateInfo from './EventSportDateInfo';
import EventTicketButton from './EventTicketButton';

import merchantConfig from '../../merchant/config/merchant-config'
import imageOutline from '../../assets/image-black.svg'

const backendBaseUrl = merchantConfig.backendUrl;

export const EventSportSummaryStyles = {
	EventSummaryWrapper: styled.div`
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      //noinspection ALL
      @media ${device.tablet} {
        align-items: center;
        flex-wrap: nowrap;
        justify-content: space-between;
      }
	`,
	EventTitleWrapper: styled.div`
      width: 100%;
      display: flex;
      align-items: center;
      text-align: center;
      font-size: 1.3rem;
      color: black;
      justify-content: center;
      order: 3;
		flex-wrap: wrap;
      //noinspection ALL
      @media ${device.tablet} {
        width: 50%;
        order: 2;
        font-size: 1.5rem;
      }
	`,
	// width: 100%; word-wrap: break-word; needed by Internet Explorer 11
	// word-break: break-word; needed by Chrome, FF, etc.
	EventTitle: styled.h2`
      width: 100%;
      word-wrap: break-word;
      word-break: break-word;
	`,
	EventSubtitle: styled.h3`
		display: block;
		width: 100%;
		font-size: 1rem;
		font-weight: 400;
		word-wrap: break-word;
		word-break: break-word;
		padding-top: 1em;
	`,
	EventTicketButton: styled.div`
      display: ${props => (props.hide ? 'none' : 'flex')};
      align-items: center;
      width: 100%;
      max-width: 550px;
      //noinspection ALL
      @media ${device.tablet} {
        width: 200px;
      }
	`,
	StartOfSaleInfo: styled.div`
      display: ${props => (props.hide ? 'none' : 'flex')};
      width: 100%;
      color: red;
      justify-content: center;
      align-items: center;
      margin-top: 1em;

      span {
        font-size: 1rem;
      }

      i {
        font-size: 1.3rem;
        line-height: 1.85rem;
        margin-right: 0.4rem;
      }
      //noinspection ALL
      @media ${device.tablet} {
        width: 200px;
        justify-content: flex-end;
        margin-top: 0;
        span {
          font-size: 1.1rem;
        }

        i {
          font-size: 1.4rem;
        }
      }
	`,
	ImageHome: styled.div`
      display: flex;
      align-items: center;
      justify-content: center;
      height: 80px;
      width: 80px;
      order: 1;

      img {
        max-height: 100%;
        max-width: 100%;
        flex-shrink: 0
      }

      padding: 0.5em 0 0.5em 0;
      //noinspection ALL
      @media ${device.tablet} {
        height: 100px;
        width: 100px;
        padding: 0;
      }
	`,
	ImageGuest: styled.div`
      display: flex;
      align-items: center;
      justify-content: center;
      height: 80px;
      width: 80px;
      order: 2;
      padding: 0.5em 0 0.5em 0;

      img {
        max-height: 100%;
        max-width: 100%;
        flex-shrink: 0
      }
      //noinspection ALL
      @media ${device.tablet} {
        order: 3;
        height: 100px;
        width: 100px;
        padding: 0;
      }
	`,
	EventTitleImageContainer: styled.div`
      display: flex;
      justify-content: space-around;
      width: 100%;
      flex-wrap: wrap;
      //noinspection ALL
      @media ${device.tablet} {
        justify-content: space-between;
        flex-wrap: nowrap;
        align-items: center;
        width: 60%;
        padding: 0 1.2em 0 1.2em;
      }
	`,
};

const S = EventSportSummaryStyles;

class EventSportSummary extends React.Component {
	constructor(props) {
		super(props);

		const showTicketButton = props.event.lifecyclePhase === 'ON_SALE';
		const startOfSaleText = props.event.startOfSale ? props.event.startOfSale : 'Vorverkauf hat noch nicht begonnen.';

		const imageHome = props.event.images[1] ? `${backendBaseUrl}/api/public/v1/files/scaled/IMG600/${props.event.images[1].fileMetaDataId}` : null;
		const imageGuest = props.event.images[2] ? `${backendBaseUrl}/api/public/v1/files/scaled/IMG600/${props.event.images[2].fileMetaDataId}` : null;

		this.state = {
			startOfSaleText,
			showTicketButton,
			imageHome,
			imageGuest
		};
	}

	render() {
		return (
			<S.EventSummaryWrapper>
				<EventSportDateInfo event={this.props.event}/>
				<S.EventTitleImageContainer>
					<S.ImageHome>
						{this.state.imageHome ?
							<img src={this.state.imageHome} alt="ImageHome"/> :
							<img className="placeholderImageHome" src={imageOutline} alt="placeholderImageHome"/>}
					</S.ImageHome>
					<S.EventTitleWrapper>
						<S.EventTitle>{this.props.event.title}</S.EventTitle>
						{
							this.props.event.subtitle && this.props.event.subtitle.length > 0 &&
							<S.EventSubtitle>{this.props.event.subtitle}</S.EventSubtitle>
						}
					</S.EventTitleWrapper>
					<S.ImageGuest>
						{this.state.imageGuest ?
							<img src={this.state.imageGuest} alt="ImageGuest"/> :
							<img className="placeholderImageGuest" src={imageOutline} alt="placeholderImageGuest"/>}
					</S.ImageGuest>
				</S.EventTitleImageContainer>
				<S.EventTicketButton hide={!this.state.showTicketButton && true}>
					<EventTicketButton event={this.props.event}/>
				</S.EventTicketButton>
				<S.StartOfSaleInfo hide={this.state.showTicketButton && true}>
					<i className="material-icons">info</i><span>{this.state.startOfSaleText}</span>
				</S.StartOfSaleInfo>
			</S.EventSummaryWrapper>
		);
	}
}


export default EventSportSummary;
